export const TOP_CATEGORY_CARD_NAMES = {
  DESTINATION: 'destinations',
  JOURNEY: 'journeys',
  STAY: 'stays',
  EXPERIENCE: 'experiences',
  GASTRONOMY: 'gastronomy',
} as const;
